import { ArgumentError } from '../utils/errors';

import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class QuotasModel extends BaseAPIModel {
    fields() {
        return {
            uuid: { readOnly: true, primaryKey: true }
        };
    }

    get rateKey() {
        const sortedRates = this.object.rates.sort();
        return sortedRates.join('-');
    }

    get id() {
        return this.object.uuid;
    }

    get getTotalBookings() {
        return this.object.booked + this.object.booking_in_progress;
    }

    setTotal(value) {
        this.object.total = value;
    }

    getItemUrl({ organizationId, eventId, inventoryId }) {
        return `/ticket/organizations/${organizationId}/events/${eventId}/inventories/${inventoryId}/quotas/${this.pk}`;
    }

    static listUrl({ organizationId, eventId, inventoryId, getForRates = false }) {
        if (!organizationId || !eventId) {
            throw new ArgumentError(`[Model][Quotas][getAll] organizationId, eventId and inventoryId are mandatory`);
        }
        if (getForRates) {
            return `/ticket/organizations/${organizationId}/events/${eventId}/rates/quotas`;
        }

        if (!inventoryId) {
            throw new ArgumentError(`[Model][Quotas][getAll] inventoryId are mandatory`);
        }
        return `/ticket/organizations/${organizationId}/events/${eventId}/inventories/${inventoryId}/quotas`;
    }

    // Rates quotas related
}
